<ng-container *ngIf="srcVideo">
  <iframe class="w-full aspect-video rounded-sm overflow-hidden" [src]="srcVideo | safe" frameborder="0" allow="accelerometer" allowfullscreen></iframe>
  <p class="italic text-center mt-2" *ngIf="titleVideo"> {{titleVideo}}</p>
  <div class="mt-3" *ngIf="descVideo" >
    <quill-view [content]="descVideo" format="json" theme="snow"></quill-view>
  </div>
</ng-container>